export const COMMON = {
  SHOW_TUTORIALS: 'Show all tutorials',
  GET_STARTED_NOW: 'Get Started Now',
  SHOW_GUIDES: 'Show all guides',
  SHOW_DOCUMENTATION: 'Show documentation',
  READ_MORE: 'Read more',
  DEVELOPER: 'Developer',
  DEVOPS: 'DevOps',
  TITLE_FAQ: 'Frequently Asked Questions',
  SEE_ALL_ARTICLES: 'See all articles',
  SEE_ALL_INTERVIEWS: 'See all interviews',
  SEE_ALL_AUTHORS: 'See all authors',
  SEE_ALL_ENGINEERING: 'See all engineering',
  SEE_ALL_CASE_STUDIES: 'See all case studies',
  TITLE_REPLIBYTE: 'From The Team Behind Replibyte',
  DESCRIPTION_REPLIBYTE:
    'Replibyte is an open-source tool to seed your development databases with real data. Used by more than top 1000 companies like GitHub, Cloudflare, SAP, Microsoft, and Google.',
  TITLE_STARTED: 'Your Favorite DevOps Automation Platform',
  DESCRIPTION_STARTED:
    'Qovery is a DevOps Automation Platform Helping 200+ Organizations To Ship Faster and Eliminate DevOps Hiring Needs',
  DEPLOY_MY_APPS: 'Try it out now!',
  REPLIBYTE_BUTTON_TEXT: 'GitHub',
  TITLE_REGISTER: 'Stay up to date',
  TITLE_REGISTER_2: 'Migrate now',
  TITLE_REGISTER_3: 'Try it now',
  DESCRIPTION_REGISTER: 'Your Favorite DevOps Automation Platform',
  DESCRIPTION_REGISTER_2:
    'Pressed on bandwidth? One of our cloud consulting partners will handle all the migration for you.',
  DESCRIPTION_REGISTER_3:
    'Get a full replica of your production environment for every pull request, complete with shareable links for continuous collaboration on your AWS account.',
  REGISTER: 'Register',
  YOUR_EMAIL: 'Your email',
  TITLE_MAPS: '60000+ developers from great companies trust us',
  TAG_MAPS: 'Text to fill',
  DOCUMENTATION: 'Documentation',
  SIGN_UP: 'Sign up',
  MOST_POPULAR: 'Most popular',
  PLANS_CONDITION: '*All plans include 1000 free deployment minutes per month',
  PLAN_WARNING: 'This plan does not provide any backup. Do your own backups!',
  FREE: 'Free',
  FREE_LABEL: 'Forever free',
  DAY_TRIAL: '14 day trial',
  PROFESSIONAL: 'Professional',
  TEAM: 'Team',
  BUSINESS: 'Business',
  ENTERPRISE: 'Enterprise',
  TITLE_COMPARE_PRICE: 'Compare Plans',
  TAG_COMPARE_PRICE: 'Pay for only what you deploy',
  FEATURES: 'Features',
  CLOUD_SERVICES: 'Providers',
  DATABASES: 'Databases',
  ADDONS: 'Addons',
  SUPPORT: 'Support',
  QUICK_START_FOR_FREE: 'Quick Start for Free',
  SCHEDULE_A_DEMO: 'Schedule a Demo',
  GET_A_DEMO: 'Get a Demo',
  BOOK_A_DEMO: 'Book a demo',
  GET_STARTED: 'Get started',
  FOUNDERS: 'Founders',
  AMBASSADORS: 'Ambassadors',
  INVESTORS: 'Investors',
  CORE_TEAM: 'Core Team',
  TOP_ARTICLE: 'Top article',
  RECOMMENDED_ARTICLES: 'Recommended articles',
  ALL_BLOG_ARTICLES: 'all blog articles',
  ALL_TECH_STORIES: 'all tech stories',
  MIN_READ: 'min read',
  ENGINEERING: 'Engineering',
  INTERVIEWS: 'Interviews',
  TECH_STORY_ARTICLES: 'Tech story articles',
  AUTHORS: 'Authors',
  RECENT_POSTS: 'Recent posts',
  LEARN_MORE: 'Learn more',
  LEARN_MORE_ABOUT_QOVERY: 'Latest news',
  ADDITIONAL_RESOURCES: 'Additional Resources',
  OUR_PRECIOUS_AUTHORS: 'Our precious authors',
  NEWSLETTER_PARAGRAPH: 'Sign up to receive the latest news from Qovery',
  WRITTEN_BY: 'Written by',
  INTERVIEWED_BY: 'Interviewed by',
  WATCH_DEMO: 'Watch demo',
  VIEW_DOCS: 'View docs',
  CASE_STUDIES: 'Case studies',
  COMPANY: 'Company',
  HEADQUARTERS: 'Headquarters',
  FOUNDED: 'Founded',
  COMPANY_SIZE: 'Company size',
  KEY_CHALLENGES: 'Key challenges',
  SOLUTIONS: 'Solutions',
  KEY_RESULTS: 'Key results',
  READ_THE_USE_CASE: 'Read this use case',
  READ_THE_INTERVIEW: 'Read the interview',
  USE_CASES: 'Use cases',
  USE_CASE: 'Use case',
  TITLE_USE_CASES: 'Perfect Use Cases Covered',
  SECTION_CASE_STUDIES: 'Don’t take our words for granted',
  TUTORIALS: 'Tutorials',
  TUTORIAL: 'Tutorial',
  TITLE_TUTORIALS: 'Simple step-by-step tutorials',
  SEE_ALL_OUR_TUTORIALS: 'See all our tutorials',
  SEE_ALL_OUR_USE_CASES: 'See all our use cases',
  VIEW_POSTS: 'View posts',
  SHOW_MORE: 'Show more',
  CHANGELOG: 'Changelog',
  BACKLOG: 'Backlog',
  CHANGELOG_DESCRIPTION: 'Follow improvements made in Qovery',
  DEPLOYMENTS_MIN: 'deployments',
  OUR_MISSION: 'Our mission',
  THANKS_SUBSCRIPTION: 'Thanks for your subscription',
  COPIED_CLIPBOARD: 'Copied to clipboard',
  EMAIL_INVALID: 'Your email is invalid',
  JOIN_US: 'Join us!',
  TITLE_HIRING: 'We are hiring remote talents',
  DESCRIPTION_HIRING:
    'Qovery is a DevOps Automation Platform Helping 200+ Organizations To Ship Faster and Eliminate DevOps Hiring Needs',
  BUTTON_HIRING: 'See all open positions',
  ENTER_YOUR_WORK_EMAIL: 'Enter your work email',
  START_MIGRATING: 'Start migrating',
  TRY_IT_NOW: 'Try it now <<',
  TESTIMONIALS: 'Testimonials',
  TESTIMONIALS_TITLE: "Don't take our words for granted",
  TITLE_MORE_ARTICLE: 'You might also like',
  SECTION_LINK_TOOLS: 'See all 125 integrations with Qovery',
  CUSTOMERS: 'Customers',
  SECTION_TRY_QOVERY_TITLE: 'Ready to try Qovery?',
  SECTION_TRY_QOVERY_DESCRIPTION: 'Duplicate your infrastructure and create blueprint environments in your cloud now!',
  SECTION_TRY_QOVERY_LINK: 'Sign up now',
  READ: 'Read',
  SECTION_G2_TAG: 'We’re on G2',
  SECTION_G2_TITLE: 'We’re on G2',
  SECTION_G2_DESCRIPTION:
    'Our users have spoken. Qovery ranks as a G2 high performer across Infrastructure and DevOps categories.',
  VIDEOS: 'Videos',
  LATEST_VIDEO: 'Latest video',
  PARTNERS: 'Partners',
  LATEST_PARTNERSHIP: 'Latest partnership',
  EVENTS: 'Events',
  LATEST_EVENTS: 'Latest events',
  SEE_ALL_LOGS: 'See all logs',
  SEE_DOCUMENTATION: 'See documentation',
  TITLE_SECTION_CASE_STUDIES: 'Trusted by 200+ Organizations Worldwide',
  DESCRIPTION_SECTION_CASE_STUDIES:
    'Learn more about the companies using Qovery to streamline their infrastructure and application deployment process.',
  READ_ALL_CUSTOMER_STORIES: 'Read all customer stories',
  SUMMARY: 'Table of Contents',
}

export const LINK = {
  QOVERY_CONSOLE: 'https://start.qovery.com',
  REPLIBYTE_GITHUB: 'https://github.com/Qovery/replibyte',
  QOVERY_CONSOLE_FREE_PLAN: 'https://start.qovery.com?plan=free',
  QOVERY_CONSOLE_TEAM_PLAN: 'https://start.qovery.com?plan=tean',
  QOVERY_CONSOLE_PROFESSIONAL_PLAN: 'https://start.qovery.com?plan=professional',
  QOVERY_CONSOLE_BUSINESS_PLAN: 'https://start.qovery.com?plan=business',
  QOVERY_CONSOLE_ENTERPRISE_PLAN: 'https://start.qovery.com?plan=enterprise',
  QOVERY_GUIDES: 'https://hub.qovery.com/guides',
  QOVERY_DOCUMENTATION: 'https://hub.qovery.com/docs',
  SCHEDULE_A_DEMO: 'https://www.qovery.com/request-access?formId=yFDkReLr',
}
